import { useEffect } from 'react';
import youtubeService from '../services/youtubeService';

/**
 * Custom hook to handle YouTube API initialization
 * @param {function} setYtApiReady - Function to set the API ready state
 * @returns {boolean} Whether the YouTube API is ready
 */
export const useYouTubeAPI = (setYtApiReady) => {
  useEffect(() => {
    const initializeAPI = async () => {
      try {
        await youtubeService.loadAPI();
        setYtApiReady(true);
      } catch (error) {
        console.error('Failed to initialize YouTube API:', error);
        setYtApiReady(false);
      }
    };

    // Check if already loaded
    if (youtubeService.isReady()) {
      setYtApiReady(true);
    } else {
      initializeAPI();
    }

    // Cleanup
    return () => {
      // Remove global callback if it exists
      window.onYouTubeIframeAPIReady = null;
    };
  }, [setYtApiReady]);

  return youtubeService.isReady();
};

export default useYouTubeAPI;
